import { useTranslation } from 'react-i18next';

import { AiAssistantMessage } from './AiAssistantMessage';
import type { AiAssistantMessage as AiAssistantMessageModel } from './types';

import styles from './AiAssistantMessageList.module.scss';

type AiAssistantMessageListProps = {
  activeSourcesMessageId?: string;
  messages: AiAssistantMessageModel[];
  onCopy: (message: AiAssistantMessageModel) => Promise<boolean>;
  onJumpToSource: (message: AiAssistantMessageModel, number: number) => void;
  onNavigate?: (to: string) => void;
  onOpenSources: (message: AiAssistantMessageModel) => void;
};

export function AiAssistantMessageList({
  activeSourcesMessageId,
  messages,
  onCopy,
  onJumpToSource,
  onNavigate,
  onOpenSources,
}: AiAssistantMessageListProps) {
  const { t } = useTranslation();

  return (
    <>
      <p className={styles['disclaimer']}>{t('app.aiAssistant.disclaimer')}</p>
      {messages.map((message) => (
        <AiAssistantMessage
          isSourcesActive={activeSourcesMessageId === message.id}
          key={message.id}
          message={message}
          onCopy={onCopy}
          onJumpToSource={onJumpToSource}
          onNavigate={onNavigate}
          onOpenSources={onOpenSources}
        />
      ))}
    </>
  );
}
